<template>
    <b-card no-body class="overflow-hidden">
        <b-overlay :show="getting" opacity="0.5">
            <div class="p-1">
                <div class="row align-items-center gy-50">
                    <div class="col-md-1 mb-1 mb-md-0">
                        <select class="form-control bg-img-none" v-model="donem.month">
                            <option :value="0">Tüm Aylar</option>
                            <option v-for="m in months" :key="m.index" :value="m.index">{{ m.name }}</option>
                        </select>
                    </div>
                    <div class="col-md-1 mb-1 mb-md-0">
                        <select class="form-control bg-img-none" v-model="donem.year">
                            <option v-for="y in years" :key="y" :value="y">{{ y }}</option>
                        </select>
                    </div>
                    <div class="col-md-2 mb-1 mb-md-0">
                        <select class="form-control bg-img-none" v-model="statusFilter">
                            <option :value="0">Tüm Çıkışlar</option>
                            <option :value="1">Devam Eden</option>
                            <option :value="2">Tamamlanmış</option>
                        </select>
                    </div>
                    <div class="col-md-2 mb-1 mb-md-0">
                        <v-select-list append-to-body :options="sbranches" label="Name" v-model="sbranch" placeholder="Tüm SGK Şubeler"></v-select-list>
                    </div>
                    <div class="col-md-2 mb-1 mb-md-0">
                        <select class="form-control bg-img-none" v-model="sortBy">
                            <option :value="0">Sıralama: Ada göre (A→Z)</option>
                            <option :value="1">Sıralama: Çıkış tarihi (yeni→eski)</option>
                        </select>
                    </div>
                    <div class="col-md-2 mb-1 mb-md-0">
                        <input placeholder="Ara..." class="form-control" v-model="search" v-on:keypress.enter="get()" />
                    </div>
                    <div class="col-auto">
                        <button class="btn btn-success" v-on:click="get">Sorgula</button>
                    </div>
                    <div class="col-auto">
                        <button class="btn btn-outline-success" :disabled="exporting" v-on:click="exportToExcel">
                            <b-spinner small v-if="exporting" class="mr-50"></b-spinner>
                            <feather-icon v-else icon="DownloadIcon" class="mr-50" />
                            Excel
                        </button>
                    </div>
                </div>
            </div>
            <div class="mx-1">
                <div class="row">
                    <div class="col-auto mb-1">
                        <div class="d-flex px-50 py-25 bg-light-success rounded align-items-center font-weight-bolder">
                            <span class="material-icons-outlined d-block mr-50">check_circle</span>
                            Yüklendi
                        </div>
                    </div>
                    <div class="col-auto mb-1">
                        <div class="d-flex px-50 py-25 bg-light-warning rounded align-items-center font-weight-bolder">
                            <span class="material-icons-outlined d-block mr-50">cancel</span>
                            Eksik / Yüklenmedi
                        </div>
                    </div>
                    <div class="col-auto mb-1">
                        <div class="d-flex px-50 py-25 bg-light-secondary rounded align-items-center font-weight-bolder">
                            <span class="material-icons-outlined d-block mr-50">remove</span>
                            Bu çıkışta beklenmez
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-responsive mb-0 exit-sticky-table">
                <table class="table table-sm bordered-header">
                    <thead>
                        <tr>
                            <th class="sticky-col-personel">Personel</th>
                            <th class="text-center sticky-col-status">Durum</th>
                            <th
                                v-for="(t, i) in titles"
                                class="text-nowrap text-center"
                                v-b-tooltip.noninteractive.hover.bottom
                                :title="$safe(t, 'FileName')"
                                :key="i"
                            >
                                {{ $safe(t, "Index") }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="($safe(datas, 'AllEmployees.Data') || []).length == 0">
                            <tr>
                                <td colspan="1000" class="text-center">Henüz bir veri bulunmamaktadır.</td>
                            </tr>
                        </template>
                        <template v-for="(v, i) in $safe(datas, 'AllEmployees.Data') || []">
                            <tr :key="i">
                                <td class="text-nowrap sticky-col-personel">
                                    <div class="d-flex align-items-center">
                                        <span
                                            class="material-icons-outlined mr-50"
                                            :class="v.Completed ? 'text-success' : 'text-warning'"
                                            v-b-tooltip.noninteractive.hover.right
                                            :title="v.Completed ? 'Çıkış tamamlandı' : 'Çıkış devam ediyor'"
                                            style="font-size: 1rem;"
                                        >{{ v.Completed ? 'lock' : 'hourglass_empty' }}</span>
                                        <div>
                                            <div>{{ $safe(v, "EmployeeFullName") }}</div>
                                            <small class="text-muted">{{ $safe(v, "ExitDateStr") }} · {{ $safe(v, "ExitCauseName") }}</small>
                                        </div>
                                    </div>
                                </td>
                                <td class="text-center sticky-col-status">
                                    <span
                                        v-if="employeeComplete(v)"
                                        class="material-icons-outlined text-success d-block"
                                        v-b-tooltip.noninteractive.hover.right
                                        title="Beklenen tüm evraklar yüklü"
                                    >task_alt</span>
                                    <span
                                        v-else
                                        class="material-icons-outlined text-danger d-block"
                                        v-b-tooltip.noninteractive.hover.right
                                        :title="employeeMissingTooltip(v)"
                                    >error_outline</span>
                                </td>
                                <td
                                    class="border-left text-center"
                                    v-for="(t, j) in titles"
                                    :key="j"
                                    :class="{ 'bg-muted-soft': getState(v, t.Index) === 0 }"
                                >
                                    <!-- 0 = bu çıkışta beklenmez (disabled), 1 = eksik, 2 = yüklü -->
                                    <span
                                        v-if="getState(v, t.Index) === 0"
                                        class="material-icons-outlined d-block text-secondary"
                                        v-b-tooltip.noninteractive.hover.bottom
                                        title="Bu çıkış türünde bu evrak beklenmez"
                                        style="opacity: 0.4;"
                                    >remove</span>
                                    <span
                                        v-else-if="getState(v, t.Index) === 2"
                                        class="material-icons-outlined d-block text-success"
                                        v-on:click="downloadFile(v, t.Index)"
                                        v-b-tooltip.noninteractive.hover.bottom
                                        :title="`${$safe(t, 'FileName')} — İndir`"
                                        style="cursor: pointer;"
                                    >check_circle</span>
                                    <span
                                        v-else
                                        class="material-icons-outlined d-block text-warning"
                                        v-b-tooltip.noninteractive.hover.bottom
                                        :title="`${$safe(t, 'FileName')} — Eksik`"
                                    >cancel</span>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
            <div class="px-75 mb-1 pt-1 border-top" v-if="count > 0">
                <div class="row justify-content-md-between justify-content-center">
                    <div class="col-auto mb-1 mb-md-0">
                        <div class="d-flex align-items-center text-nowrap">
                            Toplam {{ count || 0 }} kayıt arasından
                            <select class="form-control form-control-sm mx-50 per-page-select" v-model="perPage">
                                <option v-for="pp in perPages" :key="pp" :value="pp">{{ pp }}</option>
                            </select>
                            gösteriliyor.
                        </div>
                    </div>
                    <div class="col-auto mb-1 mb-md-0">
                        <b-pagination class="mb-0" v-model="page" :total-rows="count || 0" :per-page="perPage"></b-pagination>
                    </div>
                </div>
            </div>
        </b-overlay>
    </b-card>
</template>

<script>
import { BCard, BPagination, BOverlay, BSpinner, VBTooltip } from "bootstrap-vue";
import CompanyApi from "@/api/company";
import moment from "moment";
import EmployeeOperationsApi from "@/api/employee-operations";
import Additional from "@/utilities/additional";
import xlsx from "json-as-xlsx";

export default {
    components: {
        BCard,
        BOverlay,
        BPagination,
        BSpinner,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    data() {
        return {
            donem: {
                year: moment().year(),
                month: moment().month() + 1,
            },
            page: 1,
            perPage: 10,
            perPages: [10, 20, 30, 40, 50, 100],
            count: 0,
            years: [],
            datas: {},
            getting: false,
            exporting: false,
            months: [
                { index: 1, name: "Ocak" },
                { index: 2, name: "Şubat" },
                { index: 3, name: "Mart" },
                { index: 4, name: "Nisan" },
                { index: 5, name: "Mayıs" },
                { index: 6, name: "Haziran" },
                { index: 7, name: "Temmuz" },
                { index: 8, name: "Ağustos" },
                { index: 9, name: "Eylül" },
                { index: 10, name: "Ekim" },
                { index: 11, name: "Kasım" },
                { index: 12, name: "Aralık" },
            ],
            sbranches: [],
            sbranch: null,
            statusFilter: 0,
            search: null,
            // 0 = ada göre (A→Z), 1 = çıkış tarihi (yeni→eski). Backend: ExitListSortBy.
            sortBy: 0,
        };
    },
    watch: {
        page(oldV, newV) {
            if (oldV && newV && oldV != newV) {
                this.get();
            }
        },
        perPage(oldV, newV) {
            if (oldV && newV && oldV != newV) {
                this.get();
            }
        },
    },
    mounted() {
        this.configureYears();
        this.getSBranches();
    },
    methods: {
        buildRequest(skip, take) {
            return {
                BranchTypeCode: "S",
                BranchId: this.sbranch?.Id || null,
                Month: this.donem.month,
                Year: this.donem.year,
                StatusFilter: this.statusFilter,
                SortBy: this.sortBy,
                PaginateRequest: {
                    IsAscending: true,
                    OrderColumnName: "",
                    QueryParam: this.search,
                    Skip: skip,
                    Take: take,
                },
            };
        },
        get() {
            this.getting = true;
            EmployeeOperationsApi.GetExitDocumentsReport(this.buildRequest(this.page, this.perPage))
                .then((res) => {
                    if (res.data.Success) {
                        this.datas = res.data.Data || {};
                        this.count = this.$safe(this.datas, "AllEmployees.TotalCount") || 0;
                    }
                    this.getting = false;
                })
                .catch(() => {
                    this.getting = false;
                });
        },
        getSBranches() {
            CompanyApi.Branch.ListByCode("S").then((res) => {
                this.sbranches = res.data.Data;
            });
        },
        configureYears() {
            let years = [];
            let year = moment().add(1, "year").format("YYYY");
            let firstYear = 2015;
            while (firstYear <= year) {
                years.push(firstYear++);
            }
            this.years = years.reverse();
        },
        getState(employee, index) {
            const cell = (employee.DocumentsOfEmployee || []).find((d) => d.Index == index);
            return cell ? cell.State : 0;
        },
        getCell(employee, index) {
            return (employee.DocumentsOfEmployee || []).find((d) => d.Index == index) || null;
        },
        // Sadece "beklenen" (State != 0) evraklar tamamlanma hesabına girer.
        expectedDocs(employee) {
            return (employee.DocumentsOfEmployee || []).filter((d) => d.State !== 0);
        },
        employeeComplete(employee) {
            const expected = this.expectedDocs(employee);
            if (!expected.length) return false;
            return expected.every((d) => d.State === 2);
        },
        employeeMissingTooltip(employee) {
            const expected = this.expectedDocs(employee);
            const missing = expected.filter((d) => d.State !== 2).length;
            return `Eksik evrak: ${missing} / ${expected.length}`;
        },
        async downloadFile(employee, index) {
            const cell = this.getCell(employee, index);
            if (!cell || !cell.FilePath) {
                this.$toast?.warning?.("İndirilecek dosya bulunamadı.");
                return;
            }
            try {
                this.getting = true;
                const ext = cell.FilePath.split(".").pop();
                const fileName = `${cell.FileName}.${ext}`;
                const blob = await Additional.GetBlobFile(cell.FilePath);
                Additional.DownloadFile(blob.data, fileName);
                this.getting = false;
            } catch (err) {
                this.getting = false;
                this.$result?.(null, err);
            }
        },
        stateLabel(state) {
            if (state === 2) return "Yüklendi";
            if (state === 1) return "Eksik";
            return "-";
        },
        async exportToExcel() {
            this.exporting = true;
            try {
                const res = await EmployeeOperationsApi.GetExitDocumentsReport(this.buildRequest(1, 999999));
                if (!res.data.Success) {
                    this.exporting = false;
                    return;
                }
                const data = res.data.Data || {};
                const allTitles = ((data.DocumentTypes || []).slice()).sort((a, b) => a.Index - b.Index);
                const employees = data.AllEmployees?.Data || [];

                const columns = [
                    { label: "Personel", value: "EmployeeFullName" },
                    { label: "Çıkış Tarihi", value: "ExitDateStr" },
                    { label: "Çıkış Nedeni", value: "ExitCauseName" },
                    { label: "Durum", value: "Durum" },
                ];
                allTitles.forEach((t) => {
                    columns.push({ label: `${t.Index} - ${t.FileName}`, value: `doc_${t.Index}` });
                });

                const content = employees.map((emp) => {
                    const row = {
                        EmployeeFullName: emp.EmployeeFullName || "",
                        ExitDateStr: emp.ExitDateStr || "",
                        ExitCauseName: emp.ExitCauseName || "",
                        Durum: this.employeeComplete(emp) ? "Tamamlandı" : "Eksik",
                    };
                    allTitles.forEach((t) => {
                        row[`doc_${t.Index}`] = this.stateLabel(this.getState(emp, t.Index));
                    });
                    return row;
                });

                const fileName = `Cikis_Evraklari_${moment().format("YYYYMMDD_HHmm")}`;
                xlsx(
                    [{ sheet: "Çıkış Evrakları", columns, content }],
                    { fileName, extraLength: 3, writeMode: "writeFile" }
                );
            } catch (err) {
                this.$result?.(null, err);
            } finally {
                this.exporting = false;
            }
        },
    },
    computed: {
        titles() {
            return (this.$safe(this.datas, "DocumentTypes") || []).slice().sort((a, b) => a.Index - b.Index);
        },
    },
};
</script>

<style scoped>
.exit-sticky-table {
    max-height: calc(100vh - 320px);
    overflow: auto;
}
.exit-sticky-table thead th {
    position: sticky;
    top: 0;
    z-index: 3;
    background-color: #f3f2f7;
}
.exit-sticky-table thead th.sticky-col-personel {
    left: 0;
    z-index: 5;
}
.exit-sticky-table thead th.sticky-col-status {
    left: 260px;
    z-index: 5;
}
.exit-sticky-table tbody td.sticky-col-personel {
    position: sticky;
    left: 0;
    background-color: #ffffff;
    z-index: 1;
    min-width: 260px;
    max-width: 260px;
}
.exit-sticky-table tbody td.sticky-col-status {
    position: sticky;
    left: 260px;
    background-color: #ffffff;
    z-index: 1;
}
.exit-sticky-table thead th.sticky-col-personel,
.exit-sticky-table thead th.sticky-col-status {
    position: sticky;
    top: 0;
}
.bg-muted-soft {
    background-color: #f1f1f1 !important;
}
.dark-layout .exit-sticky-table thead th {
    background-color: #343d55;
}
.dark-layout .exit-sticky-table tbody td.sticky-col-personel,
.dark-layout .exit-sticky-table tbody td.sticky-col-status {
    background-color: #283046;
}
.dark-layout .bg-muted-soft {
    background-color: #3b4253 !important;
}
</style>
